import {
  Channel,
  MessageHeader,
  MessageStatus,
  Reaction,
  StreamFlag,
} from 'wukongimjssdk'

import type { MessageDraftState } from '@/redux/message-draft'

export enum MessageType {
  Text = 'TEXT',
  Image = 'IMAGE',
  Video = 'VIDEO',
  Post = 'POST',
}

// IMAGE 和 VIDEO 时 就把上传文件后获得的媒体路径 放在url里面
// 目前url字段不是数组 所以多个媒体 就需要发多个消息。 一条消息对应一个媒体
export interface MessageContent {
  url?: string
  text?: string
  type: MessageType
  id: string
}

export interface Message {
  id: string
  toUID: string
  header: MessageHeader
  clientSeq: number
  messageID: string
  messageSeq: number
  clientMsgNo: string
  streamNo?: string
  streamSeq?: number
  streamFlag: StreamFlag
  fromUID: string
  channel: Channel
  timestamp: number
  content: MessageContent
  status: MessageStatus
  reactions: Reaction[]

  draft?: MessageDraftState // For local new message display
  localStatus?: 'sending' | 'failed' // For local new message display
}

export interface ContextMessageInfo {
  messageType: string
  hasMedia: boolean
  amount: number
  timestamp: string
}
